import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class MonitoringOverlayService {
  private overlay?: HTMLElement;
  private renderer: Renderer2;
  private removeClickListener: (() => void) | null = null;

  constructor(rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  enable(onClick: () => void) {
    if (this.overlay) return;

    this.overlay = this.renderer.createElement('div');
    this.overlay.id = 'monitoring-overlay';
    this.renderer.setStyle(this.overlay, 'position', 'fixed');
    this.renderer.setStyle(this.overlay, 'top', '0');
    this.renderer.setStyle(this.overlay, 'left', '0');
    this.renderer.setStyle(this.overlay, 'width', '100vw');
    this.renderer.setStyle(this.overlay, 'height', '100vh');
    this.renderer.setStyle(this.overlay, 'background', 'rgba(0,0,0,0.0.3)');
    this.renderer.setStyle(this.overlay, 'z-index', '99');
    this.renderer.setStyle(this.overlay, 'cursor', 'pointer');

    // Use renderer.listen to attach the click handler and keep a reference
    // to the remover so we can detach it and avoid retaining closures.
    this.removeClickListener = this.renderer.listen(this.overlay, 'click', () => {
      onClick();
    });

    document.body.appendChild(this.overlay);
  }

  disable() {
    if (!this.overlay) return;

    // Remove attached click listener first to release closures
    if (this.removeClickListener) {
      try {
        this.removeClickListener();
      } catch (e) {
        // ignore
      }
      this.removeClickListener = null;
    }

    this.overlay.remove();
    this.overlay = undefined;
  }
}
